import React from "react"
import {toastr} from "react-redux-toastr"
import ReactTable, {
    ComponentPropsGetter0,
    ExpandedRows,
    Filter,
    FilteredChangeFunction,
    PageChangeFunction,
    PageSizeChangeFunction,
    RowInfo,
    SortingRule,
} from "react-table"
import {
    Button,
    Checkbox,
    CheckboxProps,
    Popup,
    Segment,
} from "semantic-ui-react"
import {
    $setProductIsDelete,
    $activateProducts,
    $validateProducts,
    $getProductRefVentes,
} from "../../core/requests"
import {
    ISupplierReference,
    IReferenceIds,
    getReferenceIdsFromList,
    getReferenceIds,
    IRawSupplierReference,
    ISupplierInfo,
    IRawSupplierDeclinedReference,
    completeRawDeclined,
    completeDeclined,
} from "../../models"
import {IProductRefVente} from "../../models/product/productRefVente"
import {convertToBoolean, Languages, Roles} from "../../utils"
import {deleteDoublonComplex, deleteDoublons} from "../../utils/doublon-tools"
import {
    getCurrentPage,
    getPageSize,
    LocalStorageColumnsKeys,
    LocalStorageKeys,
} from "../../utils/local-storage-keys"
import {ensureCorrectPopupPosition} from "../../utils/popup-tools"
import {stringify} from "../../utils/stringifyier"
import {
    topRefTableUtils,
    defaultFilterMethod,
    getTranslations,
} from "../../utils/table/methods"
import Loading from "../components/com_loading"
import MultiModifModal from "../components/com_multi-modif-modal"
import MultiModifPricesModal from "../components/com_multi-modif-prices-modal"
import {getColumns} from "../components/com_product-list-columns"
import {IFieldState} from "../product-form/_reducers/_utils/product-form-types"

interface IProductListProps {
    activeLang: Languages
    products: IRawSupplierReference[]
    isgUrl: string
    role: Roles
    comRawData: any[]
    translations: any
    supplier: ISupplierInfo
    loading: boolean
    idSocieteg: string

    fetchProducts(): Promise<boolean>

    goToProduct(droopyId: string): void

    goToProductDeclined(droopyId: string, declined: string): void
}

const returnNull = () => null

const ProductList = ({
                         products,
                         isgUrl,
                         activeLang,
                         comRawData,
                         translations,
                         role,
                         supplier,
                         loading: l,
                         idSocieteg,
                         goToProduct,
                         goToProductDeclined,
                         fetchProducts,
                     }: IProductListProps) => {
    // prettier-ignore
    const defaultShowImageValue: boolean = React.useMemo(
        () => JSON.parse(
            localStorage.getItem(LocalStorageKeys.SHOW_IMAGES) || "true"
        ), [])
    const [selectedRefs, setSelectedRefs] = React.useState<IReferenceIds[]>([])
    const [refVentes, setRefVentes] = React.useState<IProductRefVente[]>([])
    const [expandedRefs, setExpandedRefs] = React.useState<ExpandedRows>({})
    const [loading, setLoadin] = React.useState(false)
    const [showDeletedRefs, setShowDeletedRefs] = React.useState(false)
    const [showOnlyNewProducts, setShowOnlyNewProducts] = React.useState(false)
    const [showImages, setShowImages] = React.useState(defaultShowImageValue)
    const [selectedActivatedFilter, setSelectedActivatedFilter] = React.useState<
        "All" | "1" | "0"
    >("All")
    const [selectedValidatedFilter, setSelectedValidatedFilter] = React.useState<
        "All" | "True" | "False"
    >("All")
    const [displayedData, setDisplayedData] = React.useState<
        ISupplierReference[]
    >([])
    const [pageSize, setPageSize] = React.useState(
        getPageSize(supplier.supplierName, 20)
    )
    const [currentPage, setCurrentPage] = React.useState(
        getCurrentPage(supplier.supplierName, 0)
    )

    React.useEffect(() => {
        refresh()
    }, [])

    React.useEffect(() => {
        if (idSocieteg) {
            fetchRefVentes()
        }
    }, [idSocieteg])

    React.useEffect(() => {
        setPageSize(getPageSize(supplier.supplierName, 20))
        setCurrentPage(getCurrentPage(supplier.supplierName, 0))
    }, [supplier.supplierName])

    const setLoading = (value: boolean, origin: string) => {
        setLoadin(value)
    }

    const handleShowImageClick = () => {
        setShowImages((prev) => {
            window.localStorage.setItem(
                LocalStorageKeys.SHOW_IMAGES,
                JSON.stringify(!prev)
            )
            return !prev
        })
    }

    const handleChangeSelectedRefs = (
        e: React.FormEvent<HTMLInputElement>,
        data: CheckboxProps
    ) => {
        const reference: ISupplierReference = JSON.parse(data.value as string)
        const refIds = getReferenceIds(reference)
        // if (refData.length <= 0) {
        //   toastr.warning(translations.cantSelectIncompleteProduct, "")
        //   return
        // }
        let newSelectedList: IReferenceIds[]
        const variantsRawList =
            reference.declined
                ?.filter(
                    (x) =>
                        (showDeletedRefs && x.deleted) || (!showDeletedRefs && !x.deleted)
                )
                .map((x) => completeDeclined(reference, x)) || []
        const variantIds = getReferenceIdsFromList(variantsRawList)
        const topRefRaw = finalRefs.find((r) => r.supplierRef === reference.topRef)

        const addTopRef =
            topRefRaw !== undefined &&
            (topRefRaw.declined || []).every((r: IRawSupplierDeclinedReference) =>
                [...selectedRefs, refIds].find((m) => m.droopyId === r.droopyId)
            )
        const topRefIds = addTopRef ? [getReferenceIds(topRefRaw)] : []

        console.log({
            reference,
            topRefRaw,
            selectedRefs,
            variantIds,
            refIds,
            topRefIds,
        })

        if (data.checked) {
            newSelectedList = deleteDoublonComplex(
                [...selectedRefs, ...variantIds, refIds, ...topRefIds],
                "droopyId"
            )
        } else {
            newSelectedList = selectedRefs.filter(
                (r) =>
                    ![stringify(refIds), ...variantIds.map((p) => stringify(p))].includes(
                        stringify(r)
                    )
            )
        }
        setSelectedRefs(newSelectedList)
    }

    const subComp = (a: RowInfo) => {
        const ref = a.original as IRawSupplierReference
        if (ref.isTopRef) {
            return topRefTableUtils.columnsToJsx(
                subColumns,
                ref,
                goToProduct,
                showDeletedRefs
            )
        }

        return null
    }

    const [columns, subColumns] = React.useMemo(
        () => [
            getColumns({
                isgUrl,
                selectedRefs,
                refVentes,
                handleChangeSelectedRefs,
                activeLang,
                rawComTree: comRawData,
                translations,
                showImages,
                showDeletedRefs,
                idSocieteg,
                supplierName: supplier.supplierName,
                setSelectedValidatedFilter,
                selectedValidatedFilter,
                setSelectedActivatedFilter,
                selectedActivatedFilter,
            }),
            getColumns({
                isgUrl,
                selectedRefs,
                refVentes,
                handleChangeSelectedRefs,
                activeLang,
                rawComTree: comRawData,
                isSubComponent: true,
                translations,
                showImages,
                showDeletedRefs,
                idSocieteg,
                supplierName: supplier.supplierName,
                setSelectedValidatedFilter,
                selectedValidatedFilter,
                setSelectedActivatedFilter,
                selectedActivatedFilter,
            }),
        ],
        [
            stringify(selectedValidatedFilter),
            stringify(selectedActivatedFilter),
            stringify(selectedRefs),
            stringify(activeLang),
            stringify(comRawData),
            stringify(translations),
            stringify(showImages),
            stringify(showDeletedRefs),
            stringify(idSocieteg),
            stringify(refVentes),
        ]
    )

    const handleDeleteButtonClick = () => {
        setLoading(true, "handleDeleteButtonClick")
        const refsToSend = selectedRefs.filter((p) =>
            products.find(
                (pr) =>
                    (pr.supplierRef === p.supplierRef &&
                        (showDeletedRefs ? pr.deleted : !pr.deleted)) ||
                    (pr.supplierRef === p.topRef &&
                        pr.declined?.find(
                            (d) =>
                                d.supplierRef === p.supplierRef &&
                                (showDeletedRefs ? d.deleted : !d.deleted)
                        ))
            )
        )
        return $setProductIsDelete(
            refsToSend,
            !showDeletedRefs,
            role,
            supplier.supplierName
        )
            .then(() => fetchProducts())
            .finally(() => {
                setSelectedRefs([])
                setLoading(false, "handleDeleteButtonClick")
            })
    }

    const handleActivateButtonClick = (activate: boolean) => () => {
        setLoading(true, "handleActivateButtonClick")

        // const validated = products
        //   .filter(
        //     (o) =>
        //       o.supplierRef &&
        //       selectedRefs.map((e) => e.supplierRef).includes(o.supplierRef)
        //   )
        //   .map((o) => o.validated)

        const supplierRefs = selectedRefs
            .filter((x) => !x.topRef)
            .map((o) => o.supplierRef)
        const declinedSupplierRefs = selectedRefs
            .filter((x) => x.topRef)
            .map((o) => o.supplierRef)
        $activateProducts(supplierRefs, declinedSupplierRefs, activate, role)
            .then((res: Response) => {
                setLoading(false, "handleActivateButtonClick")
                setSelectedRefs([])
                return res
            })
            .then(() => fetchProducts())
    }

    console.log({
        selectedRefs,
    })

    const handleShowDeletedProductButtonClick = () => {
        setSelectedRefs([])
        setShowDeletedRefs(!showDeletedRefs)
        setShowOnlyNewProducts(false)
    }

    const handleShowNewProductsButtonClick = () => {
        setSelectedRefs([])
        setShowDeletedRefs(false)
        setShowOnlyNewProducts(!showOnlyNewProducts)
    }

    const onClickValidateProducts = () => {
        setLoading(true, "onClickValidateProducts")
        const toValidateDeclined = deleteDoublonComplex(
            selectedRefs.filter((s) => s.supplierRef.length > 0 && s.topRef),
            "supplierRef"
        )
        const toValidate = deleteDoublons([
            ...selectedRefs
                .filter((s) => s.supplierRef.length > 0 && !s.topRef)
                .map((o) => o.supplierRef),
            ...(toValidateDeclined.map((c) => c.topRef).filter((c) => c) as string[]),
        ])
        const onlyNotValidated = toValidate.filter((supplierRef) =>
            products.find((p) => p.supplierRef === supplierRef && !p.validated)
        )
        const onlyNotValidatedDeclined = toValidateDeclined.filter((s) =>
            products.find((p) => p.supplierRef === s.supplierRef && !p.validated)
        )
        if (toValidate.length !== onlyNotValidated.length) {
            toastr.confirm(translations.revalidateAlreadyValidated, {
                onOk: () =>
                    validateProducts(
                        toValidate,
                        toValidateDeclined.map((o) => o.supplierRef)
                    ),
                onCancel: () =>
                    validateProducts(
                        onlyNotValidated,
                        onlyNotValidatedDeclined.map((o) => o.supplierRef)
                    ),
                // @ts-ignore
                okText: "Oui",
                // @ts-ignore
                cancelText: "Non",
            })
        } else if (toValidate.length > 0 || toValidateDeclined.length > 0) {
            validateProducts(
                toValidate,
                toValidateDeclined.map((o) => o.supplierRef)
            )
        } else {
            setLoading(false, "onClickValidateProducts")
        }
    }

    const validateProducts = (
        toValidate: string[],
        toValidateDeclined: string[]
    ) => {
        setLoading(false, "onClickValidateProducts")
        if (toValidate.length <= 0 && toValidateDeclined.length <= 0) {
            return
        }
        $validateProducts(
            toValidate,
            toValidateDeclined,
            role,
            supplier.supplierName,
            translations
        ).then(() => {
            fetchProducts()
        })
    }

    const refresh = () => {
        fetchProducts()
    }

    const fetchRefVentes = () => {
        $getProductRefVentes(idSocieteg, role).then((res) => setRefVentes(res))
    }

    const onFieldLooseFocus = (field: IFieldState<any>) => {
        // checkFieldValidity(permanentFormIds.MULTI_MODIF, field)
    }

    const checkAllIndeter =
        selectedRefs.length > 0 && selectedRefs.length < displayedData.length

    const checkAllChecked = selectedRefs.length === displayedData.length

    const onCheckAllProducts = () => {
        const allRawRefDatas = checkAllChecked ? [] : displayedData
        // const allRefDatas = allRawRefDatas.filter((r) => r.length > 0)
        setSelectedRefs(getReferenceIdsFromList(allRawRefDatas))
    }

    const checkAllStyle = {
        position: "absolute",
        top: 92,
        left: 51,
        margin: 0,
        zIndex: 5,
    }

    const finalRefs: IRawSupplierReference[] = React.useMemo(() => {
        return products
            .filter(
                (r) =>
                    (!showOnlyNewProducts ||
                        !r.validatedOnce ||
                        (r.declined && r.declined.find((m) => !m.validatedOnce))) &&
                    ((showDeletedRefs &&
                            (r.deleted || (r.declined && r.declined.find((m) => m.deleted)))) ||
                        (!showDeletedRefs &&
                            !r.deleted &&
                            (!r.declined || r.declined.find((m) => !m.deleted))))
            )
            .map(
                (x) =>
                    ({
                        ...x,
                        refVente: refVentes.find((r) => r.refData === x.supplierRef)
                            ?.refVente,
                        declined: x.declined?.map(
                            (d) =>
                                ({
                                    ...d,
                                    refVente: refVentes.find((r) => r.refData === d.supplierRef)
                                        ?.refVente,
                                } as IRawSupplierDeclinedReference)
                        ),
                    } as IRawSupplierReference)
            )
    }, [products, showDeletedRefs, showOnlyNewProducts, refVentes])

    const defaultSorted: SortingRule[] = [
        {
            id: LocalStorageColumnsKeys.DATE_MAJ,
            desc: true,
        },
    ]

    const storedFilters = [
        {
            id: LocalStorageColumnsKeys.SUPPLIER_REF,
            value: localStorage.getItem(LocalStorageColumnsKeys.SUPPLIER_REF) || "",
        },
        {
            id: LocalStorageColumnsKeys.LABEL,
            value: localStorage.getItem(LocalStorageColumnsKeys.LABEL) || "",
        },
        {
            id: LocalStorageColumnsKeys.COM_TREE,
            value: localStorage.getItem(LocalStorageColumnsKeys.COM_TREE) || "",
        },
        {
            id: LocalStorageColumnsKeys.PRICE,
            value: localStorage.getItem(LocalStorageColumnsKeys.PRICE) || "",
        },
        {
            id: LocalStorageColumnsKeys.EAN,
            value: localStorage.getItem(LocalStorageColumnsKeys.EAN) || "",
        },
        {
            id: LocalStorageColumnsKeys.MANUFACTURER_REF,
            value:
                localStorage.getItem(LocalStorageColumnsKeys.MANUFACTURER_REF) || "",
        },
        {
            id: LocalStorageColumnsKeys.DATE_CREAT,
            value: localStorage.getItem(LocalStorageColumnsKeys.DATE_CREAT) || "",
        },
        {
            id: LocalStorageColumnsKeys.DATE_MAJ,
            value: localStorage.getItem(LocalStorageColumnsKeys.DATE_MAJ) || "",
        },
        {
            id: LocalStorageColumnsKeys.REF_VENTE,
            value: localStorage.getItem(LocalStorageColumnsKeys.REF_VENTE) || "",
        },
    ]

    const onFilterChange: FilteredChangeFunction = (
        newFiltering: Filter[],
        column: any,
        value: any
    ) => {
        newFiltering.forEach((o) => {
            localStorage.setItem(o.pivotId || o.id, o.value || "")
        })
        if (newFiltering.find((o) => o.id === column.id) === undefined) {
            localStorage.setItem(column.id, "")
        }
    }

    const handleSetFilteredData: React.Dispatch<
        React.SetStateAction<ISupplierReference[]>
    > = (data) => {
        if (stringify(data) === stringify(displayedData)) {
            return
        } else {
            setDisplayedData(data)
        }
    }

    const handleUnselectIncompleteProducts = () => {
        setSelectedRefs(selectedRefs.filter((d) => d.supplierRef))
    }
    const areIncompleteSelected =
        selectedRefs.filter((o) => o.supplierRef.length < 1).length > 0
    const validatePopupContent = showDeletedRefs ? (
        <>{translations.cantValidateDeleted}</>
    ) : (
        <>
            {translations.incompleteSelected + "  "}
            <Button
                onClick={handleUnselectIncompleteProducts}
                compact
                basic
                color="violet"
            >
                {translations.unselectIncomplete}
            </Button>
        </>
    )

    const hasSelectedHeadButNotEveryDeclined =
        selectedRefs.filter((s) =>
            s.isTopRef
                ? products.filter(
                (p) =>
                    p.topRef === s.supplierRef &&
                    !p.deleted &&
                    !selectedRefs.find((m) => m.droopyId === p.droopyId)
            ).length > 0
                : false
        ).length > 0

    const hasSelectedDeclinedButNotHead =
        selectedRefs.filter((s) =>
            s.topRef && !s.isTopRef
                ? products.filter(
                (p) =>
                    s.topRef === p.supplierRef &&
                    p.deleted &&
                    !selectedRefs.find((m) => m.droopyId === p.droopyId)
            ).length > 0
                : false
        ).length > 0

    const preventDeleteButtonClick = showDeletedRefs
        ? hasSelectedDeclinedButNotHead
        : hasSelectedHeadButNotEveryDeclined

    const deletePopupContent = preventDeleteButtonClick ? (
        <>
            {showDeletedRefs
                ? translations.restoreHeadWarning
                : translations.deleteHeadWarning}
        </>
    ) : (
        <>
            {translations.areYouSure + "  "}
            <Button
                compact
                icon="check"
                color="green"
                label={
                    (showDeletedRefs
                        ? translations.restoreConfirmationFirstPart
                        : translations.deleteConfirmationFirstPart) +
                    " " +
                    selectedRefs.length +
                    " " +
                    translations.deleteConfirmationSecondPart
                }
                onClick={handleDeleteButtonClick}
            />
        </>
    )

    const handlePageChange: PageChangeFunction = (page: number) => {
        localStorage.setItem(
            LocalStorageKeys.SELECTED_PAGE_ + supplier.supplierName,
            page + ""
        )
        setCurrentPage(page)
    }

    const handlePageSizeChange: PageSizeChangeFunction = (
        newPageSize: number,
        newPage: number
    ) => {
        localStorage.setItem(
            LocalStorageKeys.PAGE_SIZE_ + supplier.supplierName,
            newPageSize + ""
        )
        setPageSize(newPageSize)

        localStorage.setItem(
            LocalStorageKeys.SELECTED_PAGE_ + supplier.supplierName,
            newPage + ""
        )
        setCurrentPage(newPage)
    }

    // console.log({ products, finalRefs })

    return (
        <div className="product-list">
            <Checkbox
                style={checkAllStyle}
                indeterminate={checkAllIndeter}
                checked={checkAllChecked}
                onClick={onCheckAllProducts}
            />
            <ReactTable
                className="product-list-table"
                NoDataComponent={returnNull}
                loading={loading || (l && products.length < 1)}
                data={finalRefs}
                SubComponent={subComp}
                onExpandedChange={setExpandedRefs}
                expanded={expandedRefs}
                columns={columns}
                filterable={true}
                sortable={true}
                showPageJump={true}
                page={currentPage}
                onPageChange={handlePageChange}
                pageSize={pageSize}
                onPageSizeChange={handlePageSizeChange}
                showPagination={true}
                defaultFilterMethod={defaultFilterMethod}
                getTrProps={topRefTableUtils.getTrProps()}
                getTdProps={topRefTableUtils.getTdProps(goToProduct)}
                defaultFiltered={storedFilters}
                onFilteredChange={onFilterChange}
                defaultSorted={defaultSorted}
                {...getTranslations(translations)}
            >
                {(state, makeTable, instance) => {
                    const d: Array<ISupplierReference> = state.sortedData.map(
                        (o) => o._original
                    )

                    const u: ISupplierReference[] = d
                        .map((p) =>
                            p.isTopRef
                                ? [
                                    p,
                                    ...(p?.declined || []).map((x) => completeDeclined(p, x)), // TODO
                                ]
                                : p
                        )
                        .flat()

                    if (currentPage > (instance.state.pages || 1) - 1) {
                        instance.onPageChange((instance.state.pages || 1) - 1)
                    }

                    handleSetFilteredData(u)
                    return makeTable()
                }}
            </ReactTable>

            <div className="productListButtons">
                {(role === Roles.MARKET_LEADER && (
                    <div className="button-div left">
                        <Popup
                            {...ensureCorrectPopupPosition}
                            content={deletePopupContent}
                            disabled={selectedRefs.length === 0}
                            hoverable
                            position="top left"
                            flowing
                            on={preventDeleteButtonClick ? "hover" : "click"}
                            trigger={
                                <div className="button-div-button">
                                    <Button
                                        className="element button marketLeaderButton"
                                        disabled={
                                            selectedRefs.length === 0 || preventDeleteButtonClick
                                        }
                                    >
                                        {showDeletedRefs
                                            ? translations.cancelDeleteProductButtonLabel
                                            : translations.deleteProductButtonLabel}
                                    </Button>
                                </div>
                            }
                        />
                        <div className="button-div-button">
                            <Button
                                className="element button marketLeaderButton"
                                onClick={handleShowDeletedProductButtonClick}
                            >
                                {showDeletedRefs
                                    ? translations.showNonDeletedProductsButtonLabel
                                    : translations.showDeletedProductsButtonLabel}
                            </Button>
                        </div>
                        <Popup
                            {...ensureCorrectPopupPosition}
                            content={validatePopupContent}
                            hoverable
                            position="top center"
                            flowing
                            disabled={!areIncompleteSelected && !showDeletedRefs}
                            trigger={
                                <div className="button-div-button">
                                    <Button
                                        disabled={
                                            selectedRefs.length < 1 ||
                                            areIncompleteSelected ||
                                            showDeletedRefs
                                        }
                                        className="element button marketLeaderButton"
                                        onClick={onClickValidateProducts}
                                    >
                                        {translations.validateSeveralProducts}
                                    </Button>
                                </div>
                            }
                        />
                        <div className="button-div-button">
                            <Button
                                className="element button marketLeaderButton"
                                onClick={handleShowNewProductsButtonClick}
                            >
                                {showOnlyNewProducts
                                    ? translations.showAllProducts
                                    : translations.showOnlyNewProducts}
                            </Button>
                        </div>
                    </div>
                )) || <div/>}

                <div className="button-div right">
                    <Segment compact className="showImageSegment">
                        <Checkbox
                            toggle
                            fitted
                            checked={showImages}
                            onClick={handleShowImageClick}
                            label={
                                showImages
                                    ? translations.showImageButtonTrue
                                    : translations.showImageButtonFalse
                            }
                        />
                    </Segment>

                    <div className="button-div-button">
                        <MultiModifPricesModal
                            disabled={selectedRefs.length < 2}
                            selectedRefs={selectedRefs}
                            fullProductList={products}
                            onFieldLooseFocus={onFieldLooseFocus}
                            refVentes={refVentes}
                        />
                    </div>

                    <div className="button-div-button">
                        <Button
                            className="element button colored-button"
                            disabled={selectedRefs.length === 0}
                            onClick={handleActivateButtonClick(true)}
                        >
                            {translations.activateProductButtonLabel}
                        </Button>
                    </div>

                    <div className="button-div-button">
                        <Button
                            className="element button colored-button"
                            disabled={selectedRefs.length === 0}
                            onClick={handleActivateButtonClick(false)}
                        >
                            {translations.deactivateProductButtonLabel}
                        </Button>
                    </div>

                    <div className="button-div-button">
                        <MultiModifModal
                            disabled={selectedRefs.length < 2}
                            selectedRefs={selectedRefs}
                            fullProductList={finalRefs}
                            onFieldLooseFocus={onFieldLooseFocus}
                        />
                    </div>

                    <div className="button-div-button">
                        <Button
                            className="element button colored-button"
                            onClick={refresh}
                            loading={l}
                        >
                            {translations.refreshListButtonLabel}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProductList
